import { render } from "./nested.vue?vue&type=template&id=ccf3547c&scoped=true"
import script from "./nested.vue?vue&type=script&lang=js"
export * from "./nested.vue?vue&type=script&lang=js"

import "./nested.vue?vue&type=style&index=0&id=ccf3547c&scoped=true&lang=css"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccf3547c"]])

export default __exports__